import { NON_CORE_SECTION_SCORES_MAP } from "../config";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { getStatementScore } from "../statment-analysis-scoring";



export const getCertificatesScore = (certificates: ResumeAnalysis["certifications"], maxScoreOfSection: number): {
  totalScore: number;
  titleScore: number;
  linkScore: number;
  descriptionScore: number;
} => {
  const numberOfCertificates = certificates.individualCertificatesAnalysis.length;
  const scorePerCertificate = maxScoreOfSection / numberOfCertificates;

  if (numberOfCertificates === 0) return {
    totalScore: 0,
    titleScore: 0,
    linkScore: 0,
    descriptionScore: 0
  };
  let titleScore = 0;
  let linkScore = 0;
  let descriptionScore = 0;
  certificates.individualCertificatesAnalysis.forEach((cert) => {
    if (cert.certificate) {
      titleScore += scorePerCertificate * NON_CORE_SECTION_SCORES_MAP.certificates.title;
    }
    if (cert.certificateLink) {
      linkScore += scorePerCertificate * NON_CORE_SECTION_SCORES_MAP.certificates.certificateLink;
    }
    if (cert.descriptionAnalysis.length > 0) {
      const numberOfDescriptions = cert.descriptionAnalysis.length;
      const scorePerDescription = scorePerCertificate * NON_CORE_SECTION_SCORES_MAP.certificates.statementWeight / numberOfDescriptions;
      descriptionScore = 0;
      cert.descriptionAnalysis.forEach((description) => {
        const descriptionScoreResult = getStatementScore(description.analysis, scorePerDescription);
        descriptionScore += descriptionScoreResult.totalScore;
      });
      descriptionScore = Math.min(descriptionScore, scorePerCertificate * NON_CORE_SECTION_SCORES_MAP.certificates.statementWeight);

    }

  })
  return {
    totalScore: titleScore + linkScore + descriptionScore,
    titleScore,
    linkScore,
    descriptionScore
  }
}
